var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mt-4"},[(
      _vm.$store.state.user.sections['tickets'] && _vm.$store.state.user['is_root']
    )?_c('button',{staticClass:"btn btn-danger mw",on:{"click":_vm.start}},[_vm._v("\n    "+_vm._s(_vm._f("setText")("cancel_transaction","Отменить заявку"))+"\n  ")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }